import classNames from 'classnames';
import React from 'react';
import { FaCheckCircle, FaRegCircle, FaSpinner, FaTimesCircle } from 'react-icons/fa';

import { ValidationStatus, ValidationStatusHistoryInterface } from '@/api/lib/restaurant';
import { useAuthContext } from '@/contexts/auth';
import { getFormattedDate } from '@/utils/date';

interface Props {
  validationStatusHistory: ValidationStatusHistoryInterface[];
}

export const ValidationStatusHistory = ({ validationStatusHistory }: Props) => {
  const { user } = useAuthContext();

  const getStatusIcon = (status: ValidationStatus) => {
    switch (status) {
      case 'ACCEPTED':
        return <FaCheckCircle className="text-success min-w-6 min-h-6" />;
      case 'PENDING':
        return <FaSpinner className="text-primary animate-spin ring-[1px] min-w-5 min-h-5 rounded-full p-0.5 ring-primary" />;
      case 'REJECTED':
        return <FaTimesCircle className="text-red-500 min-w-6 min-h-6" />;
      default:
        return <FaRegCircle className="text-gray-400 min-w-6 min-h-6" />;
    }
  };

  const formatAuthorRole = (authorRole: 'support' | 'owner' | 'visitor') => {
    if (authorRole === 'visitor') {
      return 'un visiteur';
    }
    if (user && user.isSupport) {
      return authorRole === 'owner' ? 'le restaurateur' : "l'équipe MRH";
    }
    return authorRole === 'owner' ? 'vous' : "l'équipe MRH";
  };

  return (
    <ul className="flex w-full justify-start overflow-auto max-h-[580px] relative">
      <div className="h-full w-1 border-l-2 border-dashed border-gray-300  absolute left-4" />
      <div className="h-full flex flex-col">
        {validationStatusHistory.map((entry, index) => (
          <li key={entry.date} className={classNames(index !== validationStatusHistory.length - 1 && 'pb-7', 'relative')}>
            <div className="group relative flex items-start">
              <span className={`flex p-1.5 items-center justify-center rounded-full bg-white`}>{getStatusIcon(entry.status)}</span>

              <span className="ml-4 flex min-w-0 flex-col">
                <span className="text-sm text-gray-500">{entry.comment || 'Rédaction de la fiche du restaurant'}</span>
                <div className="flex gap-1">
                  <span className="text-xs text-gray-400">
                    Par <strong>{formatAuthorRole(entry.authorRole)}</strong> -
                  </span>
                  <span className="text-xs text-gray-400">{getFormattedDate(new Date(entry.date))}</span>
                </div>
              </span>
            </div>
          </li>
        ))}
      </div>
    </ul>
  );
};
